module.exports = __webpack_public_path__ + "static/media/icon_close.dd4f8c6a.svg";